import React from 'react'
import { getLoginInfo } from '../../../../configurations/auth/getLoginInfo'
import { BASE_URL, FOOTER_AVATAR, HEADER_AVATAR, SIDE_AVATAR, WATERMARK_AVATAR } from '../../../../configurations/initUrls'
import moment from 'moment'

// A4 + margin none — print dialog isi ko default uthata hai
const A4_PRINT_CSS = `
  @page {
    size: A4 portrait;
    margin: 0 !important;
  }

  @media print {
    html, body {
      width: 210mm !important;
      margin: 0 !important;
      padding: 0 !important;
      background: #fff !important;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }

    .rx-a4-page {
      width: 210mm !important;
      height: 296.8mm !important;
      margin: 0 !important;
      padding: 0 !important;
      overflow: hidden !important;
      box-sizing: border-box !important;
      page-break-after: always;
      break-after: page;
      page-break-inside: avoid;
      break-inside: avoid;
    }
    .rx-a4-page:last-child {
      page-break-after: auto;
      break-after: auto;
    }

    .rx-a4-page img {
      max-width: 100% !important;
      display: block;
    }
  }
`

export const PrescriptionLetterPrint = React.forwardRef((props, ref) => {
    const data = props.printData
    const userData = getLoginInfo()

    const patientName = (data?.patientName || "").toUpperCase()
    const patientAddress = (data?.patientAddress || "").toUpperCase()

    return (
        <div ref={ref}>
            <style type="text/css">{A4_PRINT_CSS}</style>

            {data &&
                <div style={{ fontSize: "10px" }}>
                    <div
                        className='rx-a4-page relative flex flex-col justify-between'
                        style={{ width: "210mm", height: "296.8mm", overflow: "hidden" }}
                    >
                        {/* HEADER */}
                        <div>
                            {userData &&
                                <img
                                    src={userData.isHeader == 1 ? BASE_URL + userData.headerUrl : HEADER_AVATAR}
                                    alt="Header"
                                    className="w-full"
                                />
                            }
                        </div>

                        {/* BODY */}
                        <div className='grow'>
                            <div className='mx-4'>
                                <hr className="w-full mt-3 h-px bg-gray-400 border-0" />
                                <div className='mx-1 flex justify-between text-[16px]'>
                                    <div>
                                        Ref No: {data.id}/{data.registeredIdForRef} |
                                        Opd Number: <span className='font-bold'>{data.confirmedAllotedNumber}</span>
                                        {data.confirmedAllotedNumber == data.opdNumberAlloted ? "" : "/" + data.opdNumberAlloted} | {patientAddress}
                                    </div>
                                    <div>
                                        Date: <span className='font-bold'>{moment(data.onDate).format("DD-MM-YYYY")}</span>
                                    </div>
                                </div>
                                <hr className="w-full h-px bg-gray-400 border-0" />
                                <div className='mx-1 flex items-center justify-between gap-2 text-[16px]'>
                                    <span>Patient: <span className='font-bold'>{patientName} ({data.gender == 0 ? "M" : "F"})</span></span>
                                    <span>BP: {data.bloodPressure} </span>
                                    <span>W: {data.weight}Kg </span>
                                    <span>Age: {data.age}Y</span>
                                    <span>BG: {data.bloodGroup} </span>
                                </div>
                                <hr className="w-full h-px bg-gray-400 border-0" />
                            </div>
                        </div>

                        {/* SIDE */}
                        <div className='w-full h-full flex'>
                            <div className='flex items-end justify-start'>
                                {userData &&
                                    <img
                                        src={userData.isSide == 1 ? BASE_URL + userData.sideUrl : SIDE_AVATAR}
                                        alt="Side"
                                        className="w-36"
                                    />
                                }
                            </div>
                            <div className='flex w-full items-center justify-center'>
                                {userData &&
                                    <img
                                        src={userData.isWaterMark == 1 ? BASE_URL + userData.waterMarkUrl : WATERMARK_AVATAR}
                                        alt="WateraMark"
                                        className="w-full"
                                    />
                                }
                            </div>
                        </div>

                        {/* FOOTER */}
                        <div className='flex flex-col items-end justify-end'>
                            {userData &&
                                <img
                                    src={userData.isFooter == 1 ? BASE_URL + userData.footerUrl : FOOTER_AVATAR}
                                    alt="Footer"
                                    className="w-full"
                                />
                            }
                        </div>
                    </div>
                </div>
            }
        </div>
    )
})